"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@0x/utils");
var NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
var MAINNET_CHAIN_ID = 1;
var DEFAULT_ASSET_BUYER_OPTS = {
    chainId: MAINNET_CHAIN_ID,
    orderRefreshIntervalMs: 10000,
    expiryBufferSeconds: 120,
};
var DEFAULT_BUY_QUOTE_REQUEST_OPTS = {
    feePercentage: 0,
    shouldForceOrderRefresh: false,
    slippagePercentage: 0.2,
};
// Other default values are dynamically determined
var DEFAULT_BUY_QUOTE_EXECUTION_OPTS = {
    feeRecipient: NULL_ADDRESS,
};
var EMPTY_ORDERS_AND_FILLABLE_AMOUNTS = {
    orders: [],
    remainingFillableMakerAssetAmounts: [],
};
exports.constants = {
    ZERO_AMOUNT: new utils_1.BigNumber(0),
    NULL_ADDRESS: NULL_ADDRESS,
    MAINNET_CHAIN_ID: MAINNET_CHAIN_ID,
    ETHER_TOKEN_DECIMALS: 18,
    DEFAULT_ASSET_BUYER_OPTS: DEFAULT_ASSET_BUYER_OPTS,
    DEFAULT_BUY_QUOTE_EXECUTION_OPTS: DEFAULT_BUY_QUOTE_EXECUTION_OPTS,
    DEFAULT_BUY_QUOTE_REQUEST_OPTS: DEFAULT_BUY_QUOTE_REQUEST_OPTS,
    EMPTY_ORDERS_AND_FILLABLE_AMOUNTS: EMPTY_ORDERS_AND_FILLABLE_AMOUNTS,
};
//# sourceMappingURL=constants.js.map